import { render } from "./chartMatrix.vue?vue&type=template&id=206f1b44"
import script from "./chartMatrix.vue?vue&type=script&lang=js"
export * from "./chartMatrix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__